export const handleResize = (halfHeight: boolean | undefined) => {
    const height = window.innerHeight - 64 - 16 - 48 - 30 - 40 - 44 - 18;
    if (halfHeight) {
        return height / 2.5;
    }

    return height;
};
